(() => {
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const wide = () => innerWidth > 820;

  // BB-keuze: replica kiezen, passende gewichten lichten op
  document.querySelectorAll('[data-a24-bb]').forEach((root) => {
    const rows = [...root.querySelectorAll('.a24-row')];
    const buttons = [...root.querySelectorAll('.a24-pick button')];
    buttons.forEach((b) => b.addEventListener('click', () => {
      buttons.forEach((x) => x.setAttribute('aria-pressed', x === b ? 'true' : 'false'));
      rows.forEach((r) => r.classList.toggle('is-on', (r.dataset.fit || '').split(' ').includes(b.dataset.r)));
    }));
  });

  // Carriers: naam aanwijzen = foto wisselen
  document.querySelectorAll('[data-a24-carriers]').forEach((root) => {
    const img = root.querySelector('.a24-carriers__shot img');
    const links = [...root.querySelectorAll('li a')];
    links.forEach((a) => {
      const show = () => {
        links.forEach((x) => x.classList.toggle('is-on', x === a));
        if (a.dataset.img) { img.src = a.dataset.img; img.srcset = ''; img.alt = a.dataset.alt || ''; }
      };
      a.addEventListener('mouseenter', show);
      a.addEventListener('focus', show);
    });
  });

  // Loadout: kaarten schuiven met de scroll
  document.querySelectorAll('[data-a24-rail]').forEach((rail) => {
    const track = rail.querySelector('.a24-track');
    const title = rail.querySelector('h2');
    const move = () => {
      if (!wide()) return;
      const r = rail.getBoundingClientRect();
      const span = rail.offsetHeight - innerHeight;
      const p = Math.min(1, Math.max(0, -r.top / span));
      const dist = track.scrollWidth - innerWidth * 0.62;
      track.style.setProperty('--x', (-p * dist) + 'px');
      title.style.setProperty('--hx', (-Math.min(1, p * 4) * innerWidth * 0.5) + 'px');
      track.querySelectorAll('.a24-cat').forEach((c) => {
        const b = c.getBoundingClientRect();
        c.classList.toggle('is-peek', b.right > innerWidth - 16 || b.left < 16);
      });
    };
    addEventListener('scroll', move, { passive: true });
    addEventListener('resize', move);
    move();
  });

  // Stappen: actieve zin loopt mee met de scroll
  document.querySelectorAll('[data-a24-steps]').forEach((root) => {
    const ps = [...root.querySelectorAll('.a24-steps__list p')];
    const imgs = [...root.querySelectorAll('.a24-duo img')];
    const io = new IntersectionObserver((es) => es.forEach((e) => {
      if (!e.isIntersecting) return;
      const i = +e.target.dataset.i;
      ps.forEach((p, k) => p.classList.toggle('is-on', k === i));
      imgs.forEach((d) => d.classList.toggle('is-on', +d.dataset.s === i));
    }), { rootMargin: '-45% 0px -45% 0px' });
    root.querySelectorAll('.a24-steps__mark').forEach((m) => io.observe(m));
  });

  // Binnenkomst van koppen, tekst en beeld
  const rise = document.querySelectorAll('.a24-rise');
  if (reduce || !('IntersectionObserver' in window)) { rise.forEach((el) => el.classList.add('is-in')); return; }
  const ro = new IntersectionObserver((es) => es.forEach((e) => {
    if (e.isIntersecting) { e.target.classList.add('is-in'); ro.unobserve(e.target); }
  }), { rootMargin: '0px 0px -8% 0px' });
  rise.forEach((el) => ro.observe(el));

  // Productkaarten met data-shot: is de foto alleen een lapje stof, toon dan de productfoto met het staal erbij.
  document.querySelectorAll('[data-shot]').forEach((img) => {
    const probe = new Image();
    probe.crossOrigin = 'anonymous';
    probe.onload = () => {
      try {
        const cv = document.createElement('canvas'); cv.width = cv.height = 16;
        const cx = cv.getContext('2d', { willReadFrequently: true });
        cx.drawImage(probe, 0, 0, 16, 16);
        const light = [[0, 0], [15, 0], [0, 15], [15, 15]].filter(([x, y]) => {
          const [r, g, b, a] = cx.getImageData(x, y, 1, 1).data;
          return a < 30 || (Math.min(r, g, b) > 196 && Math.max(r, g, b) - Math.min(r, g, b) < 20);
        }).length;
        if (light < 3 && img.dataset.fallback) {
          img.loading = 'eager'; img.removeAttribute('srcset'); img.src = img.dataset.fallback;
          const chip = img.closest('a, li')?.querySelector('[data-shot-chip]');
          if (chip) chip.hidden = false;
        }
      } catch (e) { /* geen toegang tot pixels: laat de foto staan */ }
    };
    probe.src = img.currentSrc || img.src;
  });
})();
